// =============================================================================
// Router de la aplicación (hallazgo A1 resuelto)
// -----------------------------------------------------------------------------
// Las rutas YA NO se declaran aquí: viven en `src/config/routes.js`
// (routeDefinitions), que es la fuente única. Este módulo solo las registra en
// vue-router y mantiene la guardia de navegación.
// =============================================================================
import { createRouter, createWebHistory } from 'vue-router';
import { routeDefinitions, validateMenuRoutes } from '@/config/routes';
import { session } from '@/utils/session';

const routes = routeDefinitions.map(({ path, name, component, meta }) => ({
  path,
  name,
  component,
  meta,
}));

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Guardia de navegación
// - S3: la autenticación sale de la sesión en memoria/cifrada (no de localStorage).
// - S5: las rutas con `meta.requiresPermission` también se validan contra los
//   permisos RBAC del payload de login (el servidor sigue siendo la autoridad).
// - A1: al construir el router se valida (solo en desarrollo) que toda ruta del
//   menú esté registrada.
router.beforeEach((to, from, next) => {
  const isAuthenticated = session.isAuthenticated();

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login' });
  }
  else if (to.name === 'login' && isAuthenticated) {
    next({ name: 'home' });
  }
  else if (to.meta.requiresPermission && !session.hasPermission(to.meta.requiresPermission)) {
    next({ name: 'home' });
  }
  else {
    next();
  }
});

// A1: verificación en desarrollo de que el menú actualiza rutas reales.
validateMenuRoutes();

export default router;